<template>
  <v-card
    min-height="200px"
    :dark="dark"
  >
    <BModalConfirm
      ref="modal"
      :title-text="`${actionString} ${selectedTaskName}?`"
      cancel-btn="Отмена"
      :success-btn="actionString"
      @submit="onTaskRunClick"
    />

    <v-overlay
      :value="loading"
      absolute
      color="white"
    >
      <v-progress-circular
        :size="50"
        :color="dark ? void 0 : 'primary'"
        indeterminate
      />
    </v-overlay>

    <v-card-text class="b-flex flex-column" style="min-height: 100%;">
      <div
        class="title font-weight-light mb-2"
        v-text="'Асинхронные задачи'"
      />

      <v-list v-show="!loading">
        <v-list-item v-for="item in list" :key="item.id" two-line>
          <v-list-item-content>
            <v-list-item-title>{{ getTaskName(item) }}</v-list-item-title>
            <v-list-item-subtitle>{{ getTaskDescription(item) }}</v-list-item-subtitle>
          </v-list-item-content>

          <v-list-item-action v-if="item.status !== STATUS_RUNNING">
            <v-btn icon @click.stop="onTaskRunConfirmClick(item)">
              <v-icon color="grey lighten-1">
                {{ getTaskActionIcon(item.status) }}
              </v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import { dateFormatter } from '@/helpers/dateFormatter'

import BModalConfirm from '@/components/modals/BModalConfirm.vue'

const STATUS_DONE = 'done'
const STATUS_ERROR = 'error'
const STATUS_RUNNING = 'running'

export default {
  name: 'DashboardAsyncTasks',
  components: { BModalConfirm },
  props: {
    loading: Boolean,
    dark: Boolean,
    list: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    STATUS_DONE,
    STATUS_ERROR,
    STATUS_RUNNING,
    actionString: 'Запустить',
    selectedTaskName: null,
  }),
  methods: {
    getTaskActionIcon(status) {
      switch (status) {
        case STATUS_DONE:
          return 'mdi-play-circle-outline'
        case STATUS_ERROR:
          return 'mdi-reload'
        default:
          return 'mdi-information'
      }
    },
    getTaskDescription(task) {
      switch (task.status) {
        case STATUS_DONE:
          return `Завершено. Длительность: ${Math.round(task.duration)} сек.`
        case STATUS_ERROR:
          return `Ошибка выполнения. ${task?.status_description ? task.status_description : ''}`
        case STATUS_RUNNING:
          return `Выполняется с ${dateFormatter(task.start_at)}`
        default:
          return ''
      }
    },
    getTaskName(task) {
      switch (task.name) {
        case 'ImportAllFromAteTask':
          return 'Импорт данных из сервиса АТЕ'
        default:
          return task.name
      }
    },
    onTaskRunConfirmClick(task) {
      this.actionString = task.status === STATUS_ERROR ? 'Перезапустить' : 'Запустить'
      this.selectedTaskName = task.name
      this.$refs.modal.open()
    },
    onTaskRunClick() {
      if (this.selectedTaskName) { this.$emit('onTaskRunClick', this.selectedTaskName) }
      this.$refs.modal.close()
    },
  },
}
</script>
